import { AutogenModelAllCustomers, AutogenRowAllCustomers } from "./autogen/AutogenModelAllCustomers";

export class ModelAllCustomers extends AutogenModelAllCustomers<RowAllCustomers> {
	constructor() {
		super(RowAllCustomers);
	}
}

export class RowAllCustomers extends AutogenRowAllCustomers {
}